/*
 * The links we have on our index page go to pages which have a TON of data.
 * We don't want to preload that data so we'll disable this feature.
 */
const disableCorePrefetching = () => true
export { disableCorePrefetching }

export { wrapRootElement } from './src/graphql/wrap-root-element'
